import { apiSlice } from "../apiSlice";
import { TEACHERPAYMENTS_URL } from "../../constants";


export const teacherPaymentsApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        setupPayment: builder.mutation({
            query: (data) => ({
              url: `${TEACHERPAYMENTS_URL}/paymentsetup`,
              method: 'POST',
              body: data,
            }),
          }),
          managePayments: builder.mutation({
            query: (data) => ({
              url: `${TEACHERPAYMENTS_URL}/managepayments`,
              method: 'POST',
              body: data,
            }),
          }),
          getPaymentBalance: builder.query({
            query: () => ({
              url: `${TEACHERPAYMENTS_URL}/getpaymentbalance`,
            }),
          }),
    }),
});

export const { useSetupPaymentMutation, useManagePaymentsMutation, useGetPaymentBalanceQuery } = teacherPaymentsApiSlice;
